module.exports = __webpack_public_path__ + "flyer_background_winter_065-d53264409bf723b4a28dc8bd9fc349e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_winter_065.jpg
// module id = 1705
// module chunks = 1